<template>
  <div>
    <div class="d-flex align-center mb-6">
      <v-icon color="indigo darken-1" class="mr-3" size="28">mdi-cog</v-icon>
      <h3 class="mb-0">Receiving Record</h3>
    </div>
    <v-card>
      <v-card-text>
        <v-data-table
            dense
            :headers="headers"
            :items-per-page="15"
            :items="cleanedPaymentEvents"
            show-expand
            :single-expand="true"
        >
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <div class="my-4">
                <div>Transaction Hash:
                  <small class="ml-2">{{item.transactionHash}}</small>
                </div>
                <div>
                  <div>Memo</div>
                  <code>{{item.memo}}</code>
                </div>
              </div>
            </td>
          </template>
        </v-data-table>
        <v-btn @click="refresh" depressed small :loading="refreshLoading" class="mt-4">
          <v-icon class="mr-1">mdi-refresh</v-icon>
          Refresh
        </v-btn>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import store from "@/store";
import backendCall from "@/lib/backendCall";

export default {
  name: "ReceiveRecord",
  computed: {
    cleanedPaymentEvents(){
      let cleanedPaymentEvents = Object.assign([], this.paymentEvents)
      for (let i = 0; i < cleanedPaymentEvents.length; i++) {
        cleanedPaymentEvents[i].amount = parseInt(cleanedPaymentEvents[i].amount) / (10 ** 6)
        cleanedPaymentEvents[i].sender = cleanedPaymentEvents[i].sender.address
        cleanedPaymentEvents[i].timestamp = new Date(cleanedPaymentEvents[i].timestamp * 1000).toUTCString()
      }
      return cleanedPaymentEvents
    }
  },
  mounted() {
    this.fetchPaymentEvent()
  },
  data(){
    return {
      paymentEvents: [],
      headers: [
        { text: 'Sender', value: 'sender' },
        { text: 'Amount', value: 'amount' },
        { text: 'Timestamp', value: 'timestamp' }
      ],
      refreshLoading: false
    }
  },
  methods: {
    async refresh(){
      this.refreshLoading = true
      await this.fetchPaymentEvent()
      this.refreshLoading = false
    },
    async fetchPaymentEvent(){
      try {
        const res = await backendCall.store.getStorePaymentEvents(store.state.loggedInAccount)
        if (res.status === 1){
          this.paymentEvents = res.data
        } else {
          throw Error(res.msg)
        }
      }catch (e) {
        console.error(e.message)
      }
    }
  }
}
</script>

<style scoped>

</style>